import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const create = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  const action = "afterlogin/appointmentcampaign/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const update = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const clickEvent = values && values.clickEvent;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value] ? values[value] : "");
  }
  let action = "afterlogin/appointmentcampaign/update/" + values.id;
  if (clickEvent && clickEvent === "statusupdate") {
    action = "afterlogin/appointmentcampaign/isactive/" + values.id;
  }
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const view = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  const result = values && values.result ? values.result : "";
  const appointment_type = values && values.appointment_type ? values.appointment_type : "";
  // console.log(values);
  let pagination = true;
  if (values) {
    if (values.id) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (values.pagination) {
      pagination = values.pagination;
    }
  }
  const action = page ? `afterlogin/appointmentcampaign/view?page=${page}` : `afterlogin/appointmentcampaign/view`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    client_id: values && values.client_id ? values.client_id : "",
    result: result, //business_name,owner_name
    appointment_type: appointment_type, //business_name,owner_name
  };
  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};

const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/appointmentcampaign/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const addonservices = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let appointment_campaign_id = values && values.appointment_campaign_id ? values.appointment_campaign_id : "";
  const action = page ? `afterlogin/appointmentcampaign/addonservices?page=${page}&appointment_campaign_id=${appointment_campaign_id}` : `afterlogin/appointmentcampaign/addonservices?appointment_campaign_id=${appointment_campaign_id}`;
  const data = {
    auth_key: auth_key,
    action: action
  };
  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};


const addonproducts = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let appointment_campaign_id = values && values.appointment_campaign_id ? values.appointment_campaign_id : "";
  const action = page ? `afterlogin/appointmentcampaign/addonproducts?page=${page}&appointment_campaign_id=${appointment_campaign_id}` : `afterlogin/appointmentcampaign/addonproducts?appointment_campaign_id=${appointment_campaign_id}`;
  const data = {
    auth_key: auth_key,
    action: action
  };
  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};

const sendemail = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = 'afterlogin/appointmentcampaign/sendemail';
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value] ? values[value] : "");
  }
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const AppointmentCampaignApiController = {
  create,
  update,
  view,
  deleted,
  addonservices,
  addonproducts,
  sendemail,
};
export default AppointmentCampaignApiController;
